import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import rAFTimeout from '../../helpers/rAFTimeout';
import './index.scss';

class Temperature extends PureComponent {
  constructor() {
    super();

    this.status = React.createRef();
    this.value = React.createRef();
    this.unit = React.createRef();
  }

  animate() {
    rAFTimeout(() => this.status.current.classList.add('animate-in'), 150);
    rAFTimeout(() => this.value.current.classList.add('animate-in'), 250);
    rAFTimeout(() => this.unit.current.classList.add('animate-in'), 300);
  }

  componentDidMount() {
    rAFTimeout(() => this.animate(), 400);
  }

  render() {
    return (
      <section className="current-condition">
        <div className="wrapper-temperature">
          <span ref={this.status} className="temperature__status">{this.props.weather}</span>
          <div className="temperature">
            <span ref={this.value} className="temperature__value">{this.props.temperature}</span>
            <div
              ref={this.unit}
              className="temperature__unit"
              role="button"
              tabIndex="0"
              aria-label="Toggle Celsius/Fahrenheit"
              onClick={this.props.onUnitToggle}
              onKeyPress={(e) => { if (e.key === 'Enter') { this.props.onUnitToggle && this.props.onUnitToggle(); } }}>
              <span className="temperature__unit-dot"></span>
              <span className="temperature__unit-letter">{this.props.unit || 'c'}</span>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

Temperature.propTypes = {
  weather: PropTypes.string.isRequired,
  temperature: PropTypes.number.isRequired,
  unit: PropTypes.string,
  onUnitToggle: PropTypes.func
};

export default Temperature;
